var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPasswordHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75977 0L1.05088 0.707047L2.22656 1.88279C1.26395 2.53232 0.494658 3.42983 0 4.48046C0.481153 5.50759 1.22481 6.38957 2.15586 7.03736C3.08691 7.68516 4.17241 8.07587 5.30273 8.16996C6.20713 8.15785 7.09887 7.95553 7.91996 7.57618L9.30476 8.96098L10.0118 8.25197L1.75977 0ZM5.30273 0.791016C4.74856 0.839664 4.20308 0.95986 3.67976 1.14858L5.08405 2.55483C5.23057 2.51961 5.38054 2.50124 5.53123 2.50004C6.05643 2.5002 6.5601 2.70889 6.93148 3.08027C7.30285 3.45164 7.5116 3.95526 7.51177 4.48046C7.51119 4.63108 7.49341 4.78116 7.45882 4.92776L9.27131 6.74024C10.0313 6.13189 10.6436 5.35928 11.0623 4.48046C10.5451 3.38704 9.73067 2.46122 8.71213 1.80879C7.69359 1.15636 6.51213 0.803664 5.30262 0.791016H5.30273ZM3.82624 3.48241L6.53124 6.18752C6.2281 6.36589 5.88295 6.46035 5.53123 6.46117C5.00602 6.46101 4.50246 6.25226 4.13109 5.88089C3.75972 5.50951 3.55097 5.0059 3.5508 4.48069C3.55255 4.12946 3.64766 3.78502 3.82636 3.48264L3.82624 3.48241Z",
    fill: "#B3B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.0625,
    height: 8.96094,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordHide);
export default __webpack_public_path__ + "static/media/icon_password_hide.8685ef2a274d8877ed529e6a283666ef.svg";
export { ForwardRef as ReactComponent };